/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Vehicle_TypeInputs */

const en_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle Type`)
};

const es_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de vehículo`)
};

const fr_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de véhicule`)
};

const de_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrzeugtyp`)
};

const ja_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`車両タイプ`)
};

const zh_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车辆类型`)
};

const ar_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع المركبة`)
};

const id_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Kendaraan`)
};

const it_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Veicolo`)
};

const ru_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип транспортного средства`)
};

const pt_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Veículo`)
};

const ko_field_vehicle_type = /** @type {(inputs: Field_Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차량 유형`)
};

/**
* | output |
* | --- |
* | "Vehicle Type" |
*
* @param {Field_Vehicle_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_vehicle_type = /** @type {((inputs?: Field_Vehicle_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Vehicle_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_vehicle_type(inputs)
	if (locale === "es") return es_field_vehicle_type(inputs)
	if (locale === "fr") return fr_field_vehicle_type(inputs)
	if (locale === "de") return de_field_vehicle_type(inputs)
	if (locale === "ja") return ja_field_vehicle_type(inputs)
	if (locale === "zh") return zh_field_vehicle_type(inputs)
	if (locale === "ar") return ar_field_vehicle_type(inputs)
	if (locale === "id") return id_field_vehicle_type(inputs)
	if (locale === "it") return it_field_vehicle_type(inputs)
	if (locale === "ru") return ru_field_vehicle_type(inputs)
	if (locale === "pt") return pt_field_vehicle_type(inputs)
	return ko_field_vehicle_type(inputs)
});